import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ADMIN_PROPERTIES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

const HeaderLinks = ({ onAdd }) => {
  const { t } = useTranslation();
  const canWrite = usePermission(ADMIN_PROPERTIES_WRITE);

  return (
    <IconButton
      type='add'
      fontSize='medium'
      color='transparent'
      tooltip={t('Tooltips.Property.AddNewProperty')}
      onClick={onAdd}
      disabled={!canWrite}
    />
  );
};

HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
